export const playAudio = (audioFile: string) => {
  const audio = new Audio(audioFile);
  audio.play();
};
